import { render, staticRenderFns } from "./CustomizeCompanyView.vue?vue&type=template&id=2f15ed55"
import script from "./CustomizeCompanyView.vue?vue&type=script&lang=js"
export * from "./CustomizeCompanyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports